import { createSlice } from "@reduxjs/toolkit";
import { handleOffers } from "../utils/util";

const initialState = {
  cart: [],
  totalAmount: 0,
};

const counterSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    increaseCount: (state, { payload }) => {
      const { id, foodList } = payload;

      const existingItem = state.cart.find((item) => item.id === id);

      if (existingItem) {
         existingItem.count += 1;
      } else {
         const newItem = foodList.find((item) => item.id === id);
        state.cart.push({
          id: newItem.id,
          foodData: newItem,
          price: newItem.price,
          count: 1,
          discount: newItem?.discount
        });
      }
      state.totalAmount = state.cart
        .map((item) => handleOffers(item.price, item?.discount)  * item.count)
        .reduce((total, amount) => total + amount, 0);
    },

    decreaseCount: (state, { payload }) => {
      const { id } = payload;

      const existingItem = state.cart.find((item) => item.id === id);

      if (existingItem) {
         if (existingItem.count > 1) {
          existingItem.count -= 1;
        } else {
           state.cart = state.cart.filter((item) => item.id !== id);
        }

         state.totalAmount = state.cart
          .map((item) => handleOffers(item.price, item?.discount)  * item.count)
          .reduce((total, amount) => total + amount, 0);
      }
    },
    
    removeFromCart: (state, payload) => {
      const selectedFoods = payload.payload.filteredFoodCart;
      const filteredArray = state.cart.filter((stateCart) => {
        return !selectedFoods.some(
          (selectedCart) => selectedCart.id === stateCart.id
        );
      });

      return { ...state, cart: filteredArray };
    },
    clearCart: (state, payload) => {
       state.cart = []; 
    }
  },
});

export const { increaseCount, decreaseCount, removeFromCart, clearCart } =
  counterSlice.actions;
export default counterSlice.reducer;
